import { Chip, Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { isCollectedExternally } from '@/utils/invoiceCollection';

// Known `legacy_source` tags (#2394). Anything else falls back to a generic label.
const COLLECTED_IN_KEYS: Record<string, string> = {
  innovoice: 'legacySource.collectedIn.innovoice',
};

interface ExternalCollectionChipProps {
  invoice: { legacySource?: string | null | undefined; status: string };
}

/** Marks an open imported invoice whose collection happens in the old system (#4189). */
export function ExternalCollectionChip({ invoice }: ExternalCollectionChipProps) {
  const { t } = useTranslation('common');
  if (!isCollectedExternally(invoice) || !invoice.legacySource) return null;

  const label = t(COLLECTED_IN_KEYS[invoice.legacySource] ?? 'legacySource.collectedIn.unknown');
  return (
    <Tooltip title={t('legacySource.collectedInHint')}>
      <Chip size="small" variant="outlined" label={label} data-testid="external-collection-chip" />
    </Tooltip>
  );
}
